import { select } from '@ngneat/elf';
import { selectManyByPredicate, UIEntitiesRef } from '@ngneat/elf-entities';

import { getClientsDataSource } from '@store/clients/clients.requests';
import { clientsStore } from '@store/clients/clients.store';

export class ClientsQuery {
  store = clientsStore;

  status$ = this.store.pipe(select((state) => state.status));
  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  clients$ = getClientsDataSource.data$();
  selectedClients$ = this.store.pipe(
    selectManyByPredicate((clientUI) => clientUI.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const clientsQuery = new ClientsQuery();